var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscardFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96413 2.96679L12.1418 12.1445M0.998047 7.55551C0.998047 8.41639 1.16761 9.26884 1.49706 10.0642C1.8265 10.8595 2.30938 11.5822 2.91811 12.191C3.52685 12.7997 4.24952 13.2826 5.04487 13.612C5.84022 13.9415 6.69267 14.111 7.55355 14.111C8.41444 14.111 9.26689 13.9415 10.0622 13.612C10.8576 13.2826 11.5803 12.7997 12.189 12.191C12.7977 11.5822 13.2806 10.8595 13.6101 10.0642C13.9395 9.26884 14.1091 8.41639 14.1091 7.55551C14.1091 6.69463 13.9395 5.84217 13.6101 5.04682C13.2806 4.25147 12.7977 3.5288 12.189 2.92006C11.5803 2.31133 10.8576 1.82845 10.0622 1.49901C9.26689 1.16956 8.41444 1 7.55355 1C6.69267 1 5.84022 1.16956 5.04487 1.49901C4.24952 1.82845 3.52685 2.31133 2.91811 2.92006C2.30938 3.5288 1.8265 4.25147 1.49706 5.04682C1.16761 5.84217 0.998047 6.69463 0.998047 7.55551Z",
    stroke: "#FF0000",
    strokeWidth: 1.45678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardFeedbackIcon);
export default __webpack_public_path__ + "static/media/discardFeedbackIcon.8023ca4ce81bc32d135ec7a127a8a1be.svg";
export { ForwardRef as ReactComponent };